export default __webpack_public_path__ + "static/media/project-based-learning-img.a9bdd94e.jpg";